import React, { useState, useEffect } from "react";
import Filter from "../../assets/Icons/filter.png";
import Download from "../../assets/Icons/download.png";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";
import { toast } from "react-toastify";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Close from "../../assets/Images/close.png";
import PdfIcon from "../../assets/Icons/Pdf_Icon.png";
import DownloadIcon from "../../assets/Icons/Download_Icon.png";
import ExcelExport from "../../compnenets/commons/xls";

function Checklist(props) {
  const [type, setType] = useState("list");
  const handleChangeTab = () => {
    setType("form");
  };
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  // const [checklistData, setcheckListData] = useState([]);
  const [checklist, setChecklist] = useState([]);
  const [checkListId, setCheckListId] = useState("");
  const [checkDocumentname, setCheckDocumentName] = useState("");
  const [jobFile, setJobFile] = useState("");
  const totalPages = Math.ceil(checklist?.length / rowsPerPage);

  const [standardCheckList, setStandardCheckList] = useState("");
  const [applicable, setApplicable] = useState("NA");
  const handleClick = (page) => {
    setCurrentPage(page);
  };
  const handleRowClick = (row) => {
    setCheckListId(row.QualitySOPChecklistID);
    setStandardCheckList(row.StandardChecklist);
    setApplicable(row.Applicableforthisproject);
    setCheckDocumentName(row.NameofDocument);
    setJobFile(row.SignedChecklistoftheProject);
    setType("form");
  };
  const paginatedData = checklist?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const fetchChecklist = async () => {
    const response = await PROJECT_API.getCheckList();
    // console.log(response?.QualitySOPCheckListlist);
    setChecklist(response?.QualitySOPCheckListlist);
  };
  // const fetchAdminCheck = async () => {
  //   const response = await PROJECT_API.getCheckListAdmin();
  //   // console.log(response);
  //   setChecklist(response?.Checklist);
  // };
  useEffect(() => {
    fetchChecklist();
    // fetchAdminCheck();
  }, []);
  const handleCheckFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      //  console.log("Selected file:", file);
      setJobFile(file);
    }
  };
  const handleCheckListSubmit = async () => {
    if (checkDocumentname.trim() === "" || !jobFile) {
      toast.error("Please fill in all fields!");
      return;
    }
    let response = { fileUrl: jobFile };
    if (typeof jobFile === "object") {
      response = await PROJECT_API.saveDocument(jobFile);
    }
    const usr = localStorage.getItem("state");
    const state = JSON.parse(usr);

    const payload = {
      QualityChecklistID: checkListId,
      ProjectID: props.project.project_id,
      ProjectName: props.project.Project_Name,
      StandardChecklist: standardCheckList,
      NameofDocument: checkDocumentname,
      Applicableforthisproject: applicable,
      SignedChecklistoftheProject: response.fileUrl,
      UserID: state.user.user_id,
    };
    const res = await PROJECT_API.insertUpdateCheckList(payload);
    if (res && res.Status === 200) {
      toast.success(
        `Checklist ${checkListId ? "updated" : "created"} Successfully!`
      );
      fetchChecklist();
      setType("list");
    }
  };
  const onCloseModalFilter = () => {};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };

  const usr = localStorage.getItem("state");
  const state = JSON.parse(usr);
  const [openFilter, setOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState({
    user_id: state?.user?.user_id,
    startDate: "",
    endDate: "",
    NameofDocument: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });
  const handleFilterClick = async () => {
    setCurrentPage(1);
    const response = await PROJECT_API.getCheckList(filterData);
    if (response && response.QualitySOPCheckListlist?.length) {
      setChecklist(response.QualitySOPCheckListlist);
    }
    setOpenFilter(false);
  };
  // const handleCheckListChange = (event) => {
  //   const selectedValue = event.target.value;
  //   setStandardCheckList(selectedValue);
  //   const selectedLabel = event.target.options[event.target.selectedIndex].text;
  //   if (selectedValue) {
  //     setJobDocumentName(selectedLabel);
  //   } else {
  //     setJobDocumentName("");
  //   }
  // };
  const handleChangeApplicable = (e) => {
    setApplicable(e.target.value);
  };
  const downloadFile = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    console.log(fileUrl?.split("/").pop());
    link.setAttribute("download", fileUrl?.split("/").pop());
    // link.download = decodeURIComponent(fileUrl?.split('/').pop());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the DOM
  };
  function truncateFileNameFromPath(fileName, maxLength) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
      return fileName;
    }

    const name = fileName.substring(0, dotIndex);
    const extension = fileName.substring(dotIndex);

    if (fileName.length > maxLength) {
      const visibleLength = maxLength - 1 - extension.length;
      const startLength = Math.ceil(visibleLength / 2);
      const endLength = Math.floor(visibleLength / 2);
      const truncatedName = `${name.substring(
        0,
        startLength
      )}...${name.substring(name.length - endLength)}`;
      return `${truncatedName}${extension}`;
    }

    return fileName;
  }

  return (
    <>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Checklist Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpenFilter(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Document Name</label>
                  <input
                    type="text"
                    name="NameofDocument"
                    value={filterData.NameofDocument}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => handleFilterClick(filterData)}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div
        className="select-tab d-flex align-items-center"
        style={{ marginTop: "10px", justifyContent: "space-between" }}
      >
        <div className="d-flex align-items-center flex-grow-1">
          <div
            className={`tab ${type === "list" ? "tab-active" : ""}`}
            onClick={() => setType("list")}
          >
            Checklist List
          </div>
          <div
            className={`tab ${type === "form" ? "tab-active" : ""}`}
            // onClick={() => handleChangeTab()}
            disabled
          >
            Checklist Form
          </div>
        </div>
        {type == "list" && (
          <div className="d-flex justify-content-end align-items-center">
            <div className="download-icon">
              <ExcelExport
                data={checklist?.map((val) => {
                  return {
                    "Project Name": val.ProjectName,
                    "Document Name": val.DocumentName,
                    "Standard Checklist": val.StandardChecklistName,
                    "Signed Checklist of the Project":
                      val.SignedChecklistoftheProject,
                    "Applicable for this project": val.Applicableforthisproject,
                    "Created By": val.CreatedBy,
                    "Created Date": val.CreatedDate,
                  };
                })}
                fileName="Checklist List"
                sheet="Checklist List"
              />
            </div>
            <div className="filter-icon mx-2 my-auto">
              <img
                className=""
                onClick={() => {
                  setOpenFilter(true);
                }}
                src={Filter}
                width={20}
              />
            </div>
            <div
              className="my-auto"
              onClick={() => {
                setFilterData({
                  NameofDocument: "",
                });
                fetchChecklist();
                // setTimeout(() => {
                //   fetchChecklist();
                // }, 500);
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 500,
                  background: "#8add79f7",
                  padding: 5,
                  borderRadius: 12,
                }}
              >
                Clear filters
              </span>
            </div>
          </div>
        )}
      </div>

      {type === "form" ? (
        <>
          <div className="card p-3 mt-2">
            <div className="d-flex flex-wrap">
              {/* {checkListId && (
                <>
                  <div
                    className="d-flex flex-column"
                    style={{
                      flex: "1",
                      marginRight: "30px",
                      width: "200px",
                    }}
                  >
                    <label className="input-label" htmlFor="document_id">
                      Document ID
                    </label>
                    <input
                      className="input-style"
                      type="text"
                      name="document_id"
                      id="document_id"
                      value={checkListId}
                      disabled
                    />
                  </div>
                </>
              )} */}
              <div
                className="d-flex flex-column"
                style={{
                  flex: "1",
                  marginRight: "30px",
                  width: "200px",
                }}
              >
                <label className="input-label" htmlFor="document_name">
                  Document Name
                </label>
                <input
                  className="input-style"
                  type="text"
                  name="document_name"
                  id="document_name"
                  value={checkDocumentname}
                  placeholder="Enter document name"
                  autoComplete="off"
                  disabled
                />
              </div>
              <div
                className="d-flex flex-column"
                style={{ flex: "1", marginRight: "30px", width: "200px" }}
              >
                <label className="input-label" htmlFor="standard_checklist">
                  Standard Checklist
                </label>
                {/* <select
                  name="standard_checklist"
                  className="input-style"
                  value={standardCheckList}
                  onChange={(e) => handleCheckListChange(e)}
                >
                  <option value="">Select standard Checklist</option>
                  {checklist?.length
                    ? checklist.map((val) => (
                        <option key={val.ID} value={val.ID}>
                          {val.DocumentName}
                        </option>
                      ))
                    : ""}
                </select> */}
                {standardCheckList != "" ? (
                  <>
                    <div
                      className="d-flex align-items-center justify-center"
                      style={{ marginTop: "10px" }}
                    >
                      <img
                        src={PdfIcon}
                        alt="PDF Icon"
                        style={{ width: "16px", marginRight: "8px" }}
                      />
                      {truncateFileNameFromPath(
                        decodeURIComponent(standardCheckList.split("/").pop()),
                        20
                      )}
                      <img
                        src={DownloadIcon}
                        alt="Download Icon"
                        style={{
                          width: "16px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(standardCheckList);
                        }}
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="d-flex align-items-center justify-center"
                    style={{ marginTop: "10px", fontSize: "14px" }}
                  >
                    No file choosen
                  </div>
                )}
              </div>
              <div
                className="d-flex flex-column"
                style={{ flex: "1", marginRight: "30px", width: "200px" }}
              >
                <label className="input-label" htmlFor="applicable_for">
                  Applicable for this project
                </label>
                <select
                  className="shadow-none input-style"
                  name="applicable_for"
                  id="applicable_for"
                  value={applicable}
                  style={{
                    fontSize: "14px",
                    height: "38px",
                    marginTop: "5px",
                    width: "200px",
                  }}
                  onChange={handleChangeApplicable}
                >
                  <option value="NA">Select applicable for this project</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              <div
                className="d-flex flex-column"
                style={{
                  flex: "1",
                  marginRight: "30px",
                  width: "200px",
                  // marginTop: checkListId ? "20px" : "",
                }}
              >
                <label className="input-label" htmlFor="signed_checklist">
                  Signed Checklist for this project
                </label>
                <input
                  className="input-style"
                  type="file"
                  name="signed_checklist"
                  id="signed_checklist"
                  // value={jobFile}
                  onChange={handleCheckFileChange}
                />
                {typeof jobFile !== "object" && jobFile !== "" && (
                  <>
                    <div
                      className="d-flex align-items-center justify-center"
                      style={{ marginTop: "10px" }}
                    >
                      <img
                        src={PdfIcon}
                        alt="PDF Icon"
                        style={{ width: "16px", marginRight: "8px" }}
                      />
                      <div className="d-flex">
                        {truncateFileNameFromPath(
                          decodeURIComponent(jobFile.split("/").pop()),
                          19
                        )}
                      </div>

                      <img
                        src={DownloadIcon}
                        alt="Download Icon"
                        style={{
                          width: "16px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(jobFile);
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
              <div
                className="d-flex flex-column"
                style={{
                  flex: "1",
                  marginRight: "30px",
                  width: "200px",
                  marginTop: "20px",
                }}
              >
                <label className="input-label" htmlFor="project_name">
                  Project Name
                </label>
                <input
                  className="input-style"
                  type="text"
                  name="project_name"
                  id="project_name"
                  value={props.project.Project_Name}
                  autoComplete="off"
                  style={{ width: "205px" }}
                  disabled
                />
              </div>
            </div>

            <div className="action-div">
              <div className="button-div">
                <button
                  className="btn btn-submit"
                  onClick={handleCheckListSubmit}
                >
                  Submit
                </button>
                <button
                  className="btn btn-cancel"
                  onClick={() => setType("list")}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="table-container"
            style={{
              marginLeft: "0px",
              marginRight: "0px",
              marginTop: "10px",
            }}
          >
            <table className="custom-table">
              <thead className="table-header">
                <tr>
                  <th>Sr No</th>
                  <th>Project Name</th>
                  <th>Name of Document</th>
                  <th>Standard Checklist</th>
                  <th>Applicable for this project</th>
                  <th>Signed Checklist of the project</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData?.map((checklist, index) => (
                  <tr
                    key={checklist.QualitySOPChecklistID}
                    onClick={() => handleRowClick(checklist)}
                  >
                    <td>{index + 1 + (currentPage - 1) * 10}</td>
                    <td>{checklist.ProjectName}</td>
                    <td>{checklist.NameofDocument}</td>
                    <td>
                      {/* {checklist.StandardChecklistName} */}
                      <img
                        src={PdfIcon}
                        alt="PDF Icon"
                        style={{ width: "16px", marginRight: "8px" }}
                      />
                      {truncateFileNameFromPath(
                        decodeURIComponent(
                          checklist.StandardChecklist?.split("/").pop()
                        ),
                        15
                      )}
                      <img
                        src={DownloadIcon}
                        alt="Download Icon"
                        style={{
                          width: "16px",
                          marginLeft: "8px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadFile(checklist.StandardChecklist);
                        }}
                      />
                    </td>
                    <td>{checklist.Applicableforthisproject}</td>
                    <td>
                      {checklist.SignedChecklistoftheProject != "" ||
                      checklist.SignedChecklistoftheProject != null ? (
                        <>
                          <img
                            src={PdfIcon}
                            alt="PDF Icon"
                            style={{ width: "16px", marginRight: "8px" }}
                          />
                          {truncateFileNameFromPath(
                            decodeURIComponent(
                              checklist.SignedChecklistoftheProject?.split(
                                "/"
                              ).pop()
                            ),
                            15
                          )}
                          <img
                            src={DownloadIcon}
                            alt="Download Icon"
                            style={{
                              width: "16px",
                              marginLeft: "8px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadFile(
                                checklist.SignedChecklistoftheProject
                              );
                            }}
                          />
                        </>
                      ) : (
                        <>-</>
                      )}
                    </td>
                    <td>{checklist.CreatedOn}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div
              className="pagination"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
              }}
            >
              <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                Showing{" "}
                {Math.min(
                  (currentPage - 1) * rowsPerPage + 1,
                  checklist?.length
                )}
                to {Math.min(currentPage * rowsPerPage, checklist?.length)} of{" "}
                {checklist?.length} entries
              </div>

              <div
                className="pagination-buttons"
                style={{
                  fontSize: "14px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: "5px",
                }}
              >
                <button
                  onClick={() => handleClick(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={leftArrow}
                    alt="Previous"
                    height="10px"
                    width="10px"
                    style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                  />
                </button>

                {[...Array(totalPages || 0)]?.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => handleClick(i + 1)}
                    style={{
                      background:
                        currentPage === i + 1 ? "#00B69B" : "transparent",
                      color: currentPage === i + 1 ? "#fff" : "#000",
                      border: "none",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() =>
                    handleClick(Math.min(totalPages, currentPage + 1))
                  }
                  disabled={currentPage === totalPages}
                  style={{
                    background: "none",
                    border: "none",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={rightArrow}
                    alt="Next"
                    height="10px"
                    width="10px"
                    style={{
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                  />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Checklist;
